// Define function to generate HTML markup for each location card
const generateLocationCardHTML = (location) => {

  return `
    <div ${location.lat ? `data-lat="${location.lat}"` : ""} ${
    location.lon ? `data-lon="${location.lon}"` : ""
  } class="location-card-row__card">
    <div class="location-card-row__image-wrapper">
        ${
          location?.featuredMedia?.source_url
            ? `<img class="location-card-row__image" src="${location?.featuredMedia?.source_url}" alt="${location.store}" />`
            : ""
        }
    </div>
    <div class="location-card-row__title-wrapper">
        <h3 class="location-card-row__title">${location.store}</h3>
    </div>
    ${
      location.address || location.city
        ? `
        <div class="location-card-row__address-wrapper">
            ${
              location.address
                ? `<div class="location-card-row__address-line-one">${location.address}</div>`
                : ""
            }
            ${
              location.city || location.state || location.zip
                ? `
                <div class="location-card-row__address-line-two">
                    ${
                      location.city
                        ? `<span class="location-card-row__city">${location.city}</span>`
                        : ""
                    }
                    ${
                      location.state
                        ? `<span class="location-card-row__state">${location.state}</span>`
                        : ""
                    }
                    ${
                      location.zip
                        ? `<span class="location-card-row__zip">${location.zip}</span>`
                        : ""
                    }
                </div>
            `
                : ""
            }
        </div>
    `
        : ""
    }
    <div class="location-card-row__link-wrapper">
        <div class="location-card-row__link">
            <div class="cta-button cta-button--primary">
                <a role="button" aria-label="view location details for ${
                  location.store
                }" href="${window.location.origin}/childcare-centres/${location.state}/${location.slug}">
                    <span class="cta-button__text">View Details</span>
                </a>
            </div>
        </div>
    </div>
</div>
    `;
};

const locationSearchRadius = 150;

const injectLocationCards = (locationsHTML) => {
  const gridElement = document.querySelector(
    ".location-card-row__centers-near-me-grid"
  );
  gridElement.innerHTML = locationsHTML;
};

const findNearbyCentres = async () => {
  const pagination = document.querySelector(".pagination");
  if (navigator.geolocation) {
    if (!document.body.classList.contains("centers-near-me-data-fetched")) {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        if (pagination) {
          pagination.style.display = "none";
        }

        const { latitude: userLatitude, longitude: userLongitude } =
          position?.coords;
        const metaURL = `${window.location.origin}/wp-admin/admin-ajax.php?action=store_search&lat=${userLatitude}&lng=${userLongitude}&search_radius=${locationSearchRadius}`;
        const nearbyCentres = await getJSON(metaURL);

        if (nearbyCentres) {
          let centresWithMedia = [];

          const getMediaUrl = async (centre) => {
            try {
              const centreQueryURL = `${window.location.origin}/wp-json/wp/v2/wpsl_stores?include[]=${centre.id}&_embed=true`;
              const centreQueryResponse = await getJSON(centreQueryURL);
              
              if (centreQueryResponse && centreQueryResponse.length > 0) {
                Object.assign(centre, { slug: centreQueryResponse[0].slug });
              } else {
                throw new Error('Centre query returned no results');
              }
          
              const getMediaAsset = async () => {
                try {
                  const mediaQueryURL = `${window.location.origin}/wp-json/wp/v2/media/${centreQueryResponse[0].featured_media}`;
                  const mediaQueryResponse = await getJSON(mediaQueryURL);
                  
                  if (mediaQueryResponse) {
                    Object.assign(centre, { featuredMedia: mediaQueryResponse });
                    centresWithMedia.push(centre);
                  } else {
                    throw new Error('Media query returned no results');
                  }
                } catch (mediaError) {
                  console.error('Error fetching media:', mediaError);
                }
              };
          
              return await getMediaAsset();
            } catch (centreError) {
              console.error('Error fetching centre data:', centreError);
            }
          };

          // Promise.all to await all the promises returned teh map
          Promise.all(nearbyCentres.map((centre) => getMediaUrl(centre)))
            .then((contents) => {
              const locationsHTML = centresWithMedia
                .map((location) => generateLocationCardHTML(location))
                .join("");

              injectLocationCards(locationsHTML);
            })
            .catch((error) => {
              console.error("Error occurred:", error);
            });

        } else {
          injectLocationCards(
            "<div class='location-card-row__none-found'>No Locations Found</div>"
          );
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    } else {
      if (document.body.classList.contains("centers-near-me-active")) {
        document.body.classList.remove("centers-near-me-active");

        if (pagination) {
          pagination.style.display = "flex";
        }
      } else {
        document.body.classList.add("centers-near-me-active");
        if (pagination) {
          pagination.style.display = "none";
        }
      }
    }
  } else {
    console.error("Geolocation is not supported by this browser.");
  }
};

const initializeButton = () => {
  const findButton = document.querySelector(
    ".location-card-row__search-nearby-button"
  );
  if (findButton) {
    findButton.addEventListener("click", findNearbyCentres);
  }
};

if (document.readyState !== "loading") {
  initializeButton();
} else {
  document.addEventListener("DOMContentLoaded", initializeButton);
}

const getJSON = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const button = document.querySelector(
      ".location-card-row__search-nearby-button"
    );
    button.classList.add("loading");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
          button.classList.remove("loading");
          // add active class to body
          document.body.classList.add("centers-near-me-data-fetched");
          document.body.classList.add("centers-near-me-active");
        } else {
          reject(new Error(`Error fetching ${url}: ${xhr.status}`));
          // button.innerHTML = "error";
          // button.classList.add("error");
        }
      }
    };
    xhr.open("GET", url, true);
    xhr.send();
  });
};
